import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import SmsAuth from '@/views/components/views/twoFactorAuth/SmsAuth.vue';
import TotpAuth from '@/views/components/views/twoFactorAuth/TotpAuth.vue';
import router from '@/router';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { store } from '@/store/index';
import { readUserLocale } from '@/store/main/getters';


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFactorSetup',
  props: {
    mode: null
  },
  setup(__props: any) {

const locale = computed(() => readUserLocale(store));
const logoUrl = computed(() => {
  return readUserLocale(store) === 'ja-JP'
    ? '/img/top/logo_white.min.svg'
    : '/img/top/logo_white.en.min.svg';
});

const m = defineMessages({
  checkAuthApp: '認証アプリに表示されるコードを入力してください',
  enterPhoneNumber: '電話番号を入力してください',
  saveRecoveryCode: 'リカバリーコードを保存してください',
  receiveCodeText: '確認コードが記載されたテキストメッセージを受け取ります',
  receiveCodeEmail: '確認コードが記載されたメールを受け取ります',
  totpDescription:
    '二要素認証のパスコードを確認するために、スマートフォンに認証アプリをインストールしてください。ケミカンでは、タイムベース・ワンタイムパスワード（TOTP）方式に対応した、以下のような認証アプリをご利用いただけます：',
  googleAuthenticatorApp: 'Google Authenticator（iPhone / Android）',
  microsoftAuthenticatorApp: 'Microsoft Authenticator（iPhone / Android）',
});



const confirm = ref(false);

const goBack = () => {
  router.back();
};

const moveToRecoveryCode = () => {
  confirm.value = true;
};

return { __sfc: true,locale, logoUrl, m, confirm, goBack, moveToRecoveryCode, SmsAuth, TotpAuth, sharedMessages }
}

})